module.exports = __webpack_public_path__ + "img/rb.e086e3a6.png";